// Path constants for crypto-wallet module endpoints.
//
// Centralised here so the endpoint functions reference one source of truth
// rather than hand-rolling each path string (architecture-principles §7). A
// backend prefix rename is then a single-file edit.
//
// The two paths below serve DIFFERENT tables despite both being "crypto
// wallets": CRYPTO_WALLETS lists `investor_crypto_wallet_trustlines` (per-token
// trustlines), while VASP_INVESTOR_WALLETS lists `investor_crypto_wallets` (the
// wallets the VAISP approve flow mints against the Ctrl-Alt organisation).
export const CRYPTO_WALLETS = '/api/wallets/crypto-wallets'
export const VASP_INVESTOR_WALLETS = '/api/vasp/investor-wallets'

// Wallet management. `INVESTORS` is the screen's table and per-investor detail;
// the two TRUSTLINE paths are its action pair — set one up, or re-read the one
// already submitted from the ledger.
export const WALLET_MANAGEMENT_INVESTORS = `${CRYPTO_WALLETS}/investors`
export const TRUSTLINES = `${CRYPTO_WALLETS}/trustlines`
export const TRUSTLINE_STATUS_CHECK = `${CRYPTO_WALLETS}/trustlines/status`

// Operator-facing custody wallet creation. Distinct from the service-to-service
// route under /internal — same work, different auth posture.
export const CUSTODY_WALLET = (investorId: string): string =>
  `${WALLET_MANAGEMENT_INVESTORS}/${investorId}/wallet`

// Operator approval of a wallet stuck at pending_validation → active.
export const APPROVE_CUSTODY_WALLET = (investorId: string, walletId: string): string =>
  `${CUSTODY_WALLET(investorId)}/${walletId}/approve`
